export default __webpack_public_path__ + "static/media/app-confirmreq.2a1ca491.png";